import React from 'react';
import Fade from '@material-ui/core/Fade';
import classnames from 'classnames';
import './loading.less';

/**
 * @typedef {Object} LoadingProps
 * @property {boolean} isLoading
 * @property {boolean} [isSceleton]
 * @property {React.CSSProperties} [style]
 * @property {string} [className]
 */

/**
 * @param {LoadingProps} props
 */
export default function Loading({
    isLoading, isSceleton, style, className
}) {
    const classNames = classnames('loading', className, {
        'page-sceleton-loading': isSceleton
    });

    return (
        <Fade
            in={isLoading}
            appear={!isSceleton}
            timeout={{
                enter: 250, exit: 250
            }}
        >
            <div className={classNames} style={style}>
                {isSceleton
                    ? <div className="page-sceleton" />
                    : <img src="/sui/assets/spinner.gif" className="spinner" alt="Please wait..." />}
            </div>
        </Fade>
    );
}
